"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const Arrow_1 = require("@Components/Buttons/Arrow");
const clsx_1 = __importDefault(require("clsx"));
const PaginationComponent = (props) => {
    const setCurrentPage = (page = 1) => {
        if (!props.paginationPages) {
            return;
        }
        const pagination = {
            page,
            limit: props.limit,
            refined: props.paginationPages.refined,
        };
        props.onChange(pagination);
    };
    const { paginationPages, limitPages = true } = props;
    const currentPage = paginationPages ? paginationPages.currentPage : 1;
    const lastPage = paginationPages
        ? limitPages && paginationPages.cappedLastPage
            ? paginationPages.cappedLastPage
            : paginationPages.lastPage
        : 1;
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === lastPage;
    /* Calculate which page numbers we should see in the component */
    const pagesToDisplay = Array.from({ length: 5 }, (x, i) => i + currentPage - 2)
        .filter((num) => num > 0 && num <= Math.min(Math.max(currentPage + 1, 3), lastPage))
        .slice(Math.min(lastPage, 3) * -1);
    return (react_1.default.createElement("div", { className: "pagination-container" },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('first-last', isFirstPage && 'disabled'), onClick: () => !isFirstPage && setCurrentPage(1) },
            react_1.default.createElement("p", null, "FIRST")),
        react_1.default.createElement("span", { className: (0, clsx_1.default)('arrow-left', isFirstPage && 'disabled-left') },
            react_1.default.createElement(Arrow_1.ArrowButton, { mainColor: true, type: 'left', onClick: () => setCurrentPage(currentPage - 1), disabled: isFirstPage })),
        pagesToDisplay.map((page) => (react_1.default.createElement("div", { className: (0, clsx_1.default)(page === currentPage ? 'current-page' : 'non-current-page'), onClick: () => setCurrentPage(page), key: page },
            react_1.default.createElement("p", null, page)))),
        react_1.default.createElement("span", { className: (0, clsx_1.default)('arrow-right', isLastPage && 'disabled-right') },
            react_1.default.createElement(Arrow_1.ArrowButton, { mainColor: true, type: 'right', onClick: () => setCurrentPage(currentPage + 1), disabled: isLastPage })),
        react_1.default.createElement("div", { className: (0, clsx_1.default)('first-last', isLastPage && 'disabled'), onClick: () => !isLastPage && setCurrentPage(lastPage) },
            react_1.default.createElement("p", null, "LAST"))));
};
exports.default = PaginationComponent;
